export default {
  title: 'Password must include:',
  matchLength: '10-64 characters',
  includeUppercase: 'At least one uppercase',
  includeLowercase: 'At least one lowercase',
  includeNumber: 'At least one number',
  includeSpecialSymbol: 'At least one special character',
};
